import React, {useEffect, useState} from 'react'
import {TextField} from "@mui/material";
import {useIntl} from "react-intl";
import Autocomplete from '@mui/material/Autocomplete';
import {useStyles} from "./GenericFilter.css";
import AppbarSearchField from "../freeTextSearch/AppbarSearchField";
import {motion} from "framer-motion";

const GenericFilter = ({objects, filterDefinitions, onResultsChanged}) => {
    const classes = useStyles()

    const [currentFilter, setCurrentFilter] = useState({})
    const [numResults, setNumResults] = useState(objects?.length || 0)

    // Internationalization for simple strings
    const intl = useIntl();

    // Restrict the list of objects based on the applied filters
    useEffect(() => {
        const results = objects.filter((o) => {
            for (let id in currentFilter) {
                const condition = currentFilter[id].condition
                const filter = currentFilter[id].filter

                if (!condition(o, filter)) {
                    return false
                }
            }
            return true
        })

        setNumResults(results?.length || 0)

        // Inform listener about the changed result set
        onResultsChanged(results)
    }, [currentFilter, objects])

    // Reset the filter in case of unmounting the filter view (i.e. when the user clicks "back")
    useEffect(() => {
        return () => {
            onResultsChanged(objects)
            setCurrentFilter({})
        };
    }, [])

    // Updates the filter, so that it reflects the current filter inputs
    const handleChangeFilter = (id, condition, value) => {
        const newCurrentFilter = {
            ...currentFilter,
            [id]: {
                condition: condition,
                filter: value
            }
        }
        setCurrentFilter(newCurrentFilter)
    }

    // Renders the filter component based on the provided type
    const getFilterComponent = (filterDefinition) => {
        if (filterDefinition.type === 'freeText') {
            return <AppbarSearchField
                key={filterDefinition.id}
                onTextSubmitted={(value) => handleChangeFilter(filterDefinition.id, filterDefinition.condition, value)}
                placeholder={intl.formatMessage({id: filterDefinition.id, defaultMessage: filterDefinition.id})}/>
        }

        if (filterDefinition.type === 'select') {
            return <Autocomplete
                key={filterDefinition.id}
                className={classes.searchField}
                classes={{inputRoot: classes.inputRoot}}
                size="small"
                multiple
                limitTags={2}
                id={filterDefinition.id}
                options={filterDefinition.options}
                getOptionLabel={filterDefinition.getOptionLabel}
                renderInput={(params) => (
                    <TextField {...params}
                               variant="outlined"
                               placeholder={intl.formatMessage({
                                   id: filterDefinition.id,
                                   defaultMessage: filterDefinition.id
                               })}
                    />
                )}
                onChange={(event, value) => handleChangeFilter(filterDefinition.id, filterDefinition.condition, value)}
            />
        }
    }

    return (
        <div className={classes.row}>
            <motion.div className={classes.numResultsContainer}
                        key={numResults}
                        animate={{scale: [1.05, 1.1, 1.15, 1.2, 1]}}>
                <div className={classes.numResults}>{numResults}</div>
            </motion.div>
            {filterDefinitions.map((filterDefinition) => (
                getFilterComponent(filterDefinition)
            ))}
        </div>
    )
}

export default GenericFilter
